import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import ClaimsDetails from './ClaimsDetails';
import ClaimsOverview from './ClaimsOverview';

const Claims = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className="flex flex-col gap-0 bg-custom-bg-purple w-full flex-1 h-full min-h-0 max-w-full">
      <div
        className="pl-fluid-2 rounded-xl w-fit flex items-center gap-1 mt-fluid-2 cursor-pointer select-none"
        onClick={() => setIsCollapsed((prev) => !prev)}
      >
        <h4 className="text-fluid-lg font-semibold text-acs-light-text dark:text-acs-dark-text transition-none">
          Claims Overview
        </h4>
        {isCollapsed ? (
          <ChevronRight className="w-[18px] h-[18px] text-[#223688] dark:text-[#6DE1C2] transition-none" />
        ) : (
          <ChevronDown className="w-[18px] h-[18px] text-[#223688] dark:text-[#6DE1C2] transition-none" />
        )}
      </div>

      <div className="fluid-0.5 flex flex-col flex-1 min-h-0 overflow-hidden">
        <div
          className={`transition-all duration-300 ease-in-out overflow-hidden ${
            isCollapsed ? 'max-h-0 opacity-0' : 'max-h-[500px] opacity-100'
          }`}
        >
          <ClaimsOverview />
        </div>

        <div className="flex-1 overflow-auto">
          <ClaimsDetails />
        </div>
      </div>
    </div>
  );
};

export default Claims;
